<template>
  <div>
    <div class="form-group text-center">
      <label class="mb-3" for="logSearch">Pesquisar endereço e número</label>
      <div class="form-search mb-3">
        <span class="input-icon"><i class="fa fa-search"></i></span>
        <input id="logSearch" v-model="query" class="form-control" placeholder="Ex: Av Oliveira Nicácio, 3294" type="search" @input="onInput"/>
      </div>
    </div>

    <div class="my-3">
      <div v-if="places.length">
        <div v-for="(p, idx) in places" :key="idx" class="d-flex align-items-center pointer" style="padding: 8px 0" @click="selPlace(p)">
          <div class="text-left" style="width: 40px">
            <icon class="text-muted" name="address" size="24"></icon>
          </div>
          <div>
            <div class="text-muted font-weight-bold">{{ p.placePrediction.mainText.text }}</div>
            <div class="small">{{ p.placePrediction.secondaryText?.text }}</div>
          </div>
        </div>
        <div class="d-flex align-items-center pointer" style="padding: 8px 0" @click="$emit('buscarMapa')">
          <div class="text-left" style="width: 40px">
            <icon class="text-muted" name="map" size="24"></icon>
          </div>
          <div>
            <div class="text-primary font-weight-bold">Não achei meu endereço</div>
            <div class="small">Buscar pelo mapa</div>
          </div>
        </div>
      </div>
      <div class="py-4 text-center" style="margin: 16px 0">
        <div v-if="notFound">
          <icon name="address" size="24"></icon>
          <h6 class="my-2">Rua/Avenida não encontrado</h6>
        </div>
        <a class="text-primary" href="javascript:" @click="$emit('buscarMapa')">Buscar pelo mapa</a>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/pedido-manual/IconPdv";

export default {
  components: { Icon },
  props: ['empresa'],
  data() {
    return {
      query: '',
      places: [],
      sessionToken: null,
      google: null,
      searchRadius: null,
      notFound: false
    };
  },
  methods: {
    async onInput() {
      this.notFound = false;

      if (!this.query) {
        this.places = [];
        return;
      }

      try {
        // Garante que a API esteja carregada via plugin
        if (!this.google) {
          this.google = this.$googleMaps.google;
        }

        // Cria token somente se ainda não existe
        if (!this.sessionToken) {
          this.sessionToken = this.$googleMaps.getSessionToken();
        }

        const result = await this.google.maps.places.AutocompleteSuggestion
            .fetchAutocompleteSuggestions({
              input: this.query,
              sessionToken: this.sessionToken,
              includedRegionCodes: ['BR'],
              includedPrimaryTypes: ['route'],
              locationRestriction: this.searchRadius
            });

        this.places = result?.suggestions || [];
        this.notFound = this.places.length === 0;

      } catch (err) {
        console.error('Erro ao buscar sugestões:', err);
        this.places = [];
      }
    },

    async selPlace(sug) {
      this.$store.state.load = "Aguarde..";

      try {
        const res = await sug.placePrediction.toPlace().fetchFields({
          fields: ['addressComponents'],
        });

        this.$store.state.load = false;
        const getComp = (type, isShort) => res?.place?.addressComponents?.find(c => c.types.includes(type))?.[isShort ? 'shortText' : 'longText'] || '';
        const logradouro = getComp('route');
        const numero = getComp('street_number') || '';
        const bairro = getComp('sublocality') || getComp('sublocality_level_1');
        const nome_cidade = getComp('administrative_area_level_2') || '';
        const sigla_estado = getComp('administrative_area_level_1', true) || '';
        const cep = getComp('postal_code') || '';

        if (!logradouro) {
          this.$swal('Endereço inválido. Selecione uma rua válida.');
          return;
        }

        if (nome_cidade && this.limitarCidade && this.empresa.nome_cidade !== nome_cidade) {
          this.$swal('Entregas aceitas apenas para ' + this.empresa.nome_cidade + ' - ' + this.empresa.sigla_estado + '.\nLocalização informada: ' + nome_cidade + ' - ' + sigla_estado).then(() => {
            this.$helpers.focusElement(this.menu === 1 ? 'cepForm' : 'logradouro');
          });

          return;
        }

        this.suggestions = [];
        this.sessionToken = null;

        this.$emit('selPlace', {
          logradouro,
          numero,
          bairro,
          nome_cidade,
          sigla_estado,
          cep
        });

      } catch (err) {
        this.$store.state.load = false;
        console.error('Erro ao buscar detalhes do place:', err);
        this.$swal('Erro ao validar o endereço selecionado.');
      }
    },

    getRaioCidade() {
      const lat = parseFloat(this.empresa.lat_empresa);
      const lng = parseFloat(this.empresa.long_empresa);
      const raio = parseInt(this.empresa.raio_cidade, 10) || 10000;
      const delta = raio / 111320;

      return {
        north: lat + delta,
        south: lat - delta,
        east: lng + delta,
        west: lng - delta,
      };
    }
},

  mounted() {
    this.searchRadius = this.getRaioCidade();
  },

  computed: {
    limitarCidade() {
      return this.empresa.limitar_cidade;
    }
  }
};
</script>
